import {
	httpPost, httpGet
} from "../../config/request.js"

export function selectSysParamPlatStoreSetByPlatId(params) {
	return httpPost('/base/SysParamPlatStoreSet/selectSysParamPlatStoreSetByPlatId', params)
}

// 获取我的页面最新三条公告信息
export function getAnnounceInfoThreeNew(params) {
	return httpPost('/base/baseAnnounceInfo/selectBaseAnnounceInfoListNew', params)
}

// 点击跳转公告详情
export function insertBaseAnnounceReadHistory(params) {
	return httpPost('/base/baseAnnounceInfo/insertBaseAnnounceReadHistory', params)
}

//获取二级密码接口数据进行对比
export function checkSecPassWord(params) {
	return httpPost('/memb/membInfo/checkSecPassWord', params)
}